import WithdrawalModalModule from './withdrawal-modal.module'

export default WithdrawalModalModule
